import { render, staticRenderFns } from "./PendingVerify.vue?vue&type=template&id=4b78ee44&scoped=true&"
import script from "./PendingVerify.vue?vue&type=script&lang=js&"
export * from "./PendingVerify.vue?vue&type=script&lang=js&"
import style0 from "./PendingVerify.vue?vue&type=style&index=0&id=4b78ee44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b78ee44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
